import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupB2 } from "../../../../../redux/app/orb3/groups/group-b";
import ORB3TableRows from "../ORB3TableRows";

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupB2PreviewProps = OwnProps;

function ORB3GroupB2Preview(props: ORB3GroupB2PreviewProps) {
	const record = props.orb3Record as TORB3GroupB2;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const p1 = record.itemB2P1.exitingNOXTier3;

	function renderItemP1() {
		const dateTimeLocal = `${p1.date}T${p1.time}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);
		return (
			<h4 className="font-medium uppercase">
				{utcTime.format("HH:mm")} hrs UTC on {utcTime.format("DD-MMM-YYYY")} (
				{p1.time} SMT on {moment(p1.date, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				at position {p1.latitude} | {p1.longitude}
			</h4>
		);
	}

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[operationDate, "3-B", "B", renderItemP1()],
					[null, null, "-", `Engine Status: ${record.itemB2P2.status}`],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupB2Preview;
